import gql from 'graphql-tag';

export default gql`
    fragment DocumentEmail on DocumentEmail {
        ID
        Created
        Subject
        Message
        EmailSent
        ScheduledToSendEmail
        EmailApplicant
        EmailOther
        OtherEmailAddress
        Approved
        SentToRecipientEmailAddresses

        Attachments {
            ... on File {
                ID
                Name
                Size
                AbsoluteLink
            }
            ... on Image {
                ID
                Name
                Size
                AbsoluteLink
            }
        }
    }
`;
